(() => {
  'use strict';
  const config = document.getElementById('figure-eight-product-data');
  if (!config) return;
  let data;
  try { data = JSON.parse(config.textContent); } catch { return; }
  const incoming = data;
  const $ = (selector) => document.querySelector(selector);
  const $$ = (selector) => [...document.querySelectorAll(selector)];
  const hero = $('#hero-image');
  const galleryCaption = $('#gallery-caption');
  const thumbs = $('#gallery-thumbs');
  const sizeImage = $('#size-image');
  const sizeFigure = $('#dimension-figure');
  const measurementSummary = $('#measurement-summary');
  const dialog = $('#image-dialog');
  let activeColor = 'green';
  let activeRole = 'studio';
  let zoomOpener = null;
  const roles = { studio: 'Product view', use: 'Usage illustration', size: 'Dimensions', structure: 'Green set structure' };
  const shortRoles = { studio: 'Product', use: 'In use', size: 'Size', structure: 'Structure' };

  function applyImage(element, asset) {
    if (!element || !asset?.src) return;
    element.src = asset.src;
    element.alt = asset.alt || '';
    if (asset.width) element.width = Number(asset.width);
    if (asset.height) element.height = Number(asset.height);
    if (asset.srcset) element.srcset = asset.srcset;
    else element.removeAttribute('srcset');
    if (asset.sizes) element.sizes = asset.sizes;
  }
  function galleryFor(color) {
    const v = data.variants[color];
    const entries = { studio: v.studio, use: v.use, size: v.size };
    if (v.structure?.src) entries.structure = v.structure;
    else if (color === 'green' && data.structure?.src) entries.structure = data.structure;
    return entries;
  }
  function showGallery(role) {
    const entries = galleryFor(activeColor);
    if (!entries[role]) role = 'studio';
    activeRole = role;
    const asset = entries[role];
    applyImage(hero, asset);
    galleryCaption.textContent = data.variants[activeColor].label + ' · ' + roles[role];
    $('#hero-zoom').setAttribute('aria-label', 'Enlarge ' + data.variants[activeColor].label + ' ' + roles[role].toLowerCase());
    thumbs.querySelectorAll('button').forEach(button => {
      const selected = button.dataset.galleryRole === role;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  }
  function rebuildGallery() {
    thumbs.replaceChildren();
    const entries = galleryFor(activeColor);
    for (const [role, asset] of Object.entries(entries)) {
      if (!asset?.src) continue;
      const button = document.createElement('button');
      button.className = 'thumb';
      button.type = 'button';
      button.dataset.galleryRole = role;
      button.setAttribute('aria-label', 'View ' + shortRoles[role].toLowerCase());
      button.setAttribute('aria-pressed', 'false');
      const img = document.createElement('img');
      applyImage(img, asset);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      const label = document.createElement('span');
      label.textContent = shortRoles[role];
      button.append(img, label);
      button.addEventListener('click', () => showGallery(role));
      thumbs.append(button);
    }
    showGallery(activeRole);
  }
  function setDimensionAvailability(available) {
    sizeFigure.hidden = !available;
    measurementSummary.classList.toggle('visually-hidden', available);
  }
  sizeImage.addEventListener('load', () => setDimensionAvailability(sizeImage.naturalWidth > 0));
  sizeImage.addEventListener('error', () => setDimensionAvailability(false));
  function renderPrice(variant) {
    const value = variant.priceFormatted;
    for (const node of [$('#product-price'), $('#mobile-price')]) {
      node.textContent = value || '';
      node.hidden = !value;
    }
  }
  function syncPurchase(variant) {
    const form = $('.purchase-controls');
    const input = form?.querySelector('[data-product-variant-id]');
    if (!form || !input) return;
    input.value = variant.id;
    const available = variant.available === true;
    const submit = form.querySelector('[name="add"]');
    submit.disabled = !available;
    form.querySelector('[data-add-label]').textContent = available ? 'Add to bag' : 'Sold out';
    $('[data-stock-label]').textContent = available ? 'Available' : 'Sold out';
    $('[data-purchase-note]').textContent = available ? 'Shipping options and charges are shown at checkout.' : 'This colour is currently sold out.';
    const quantity = $('#quantity');
    const rule = variant.quantityRule || {};
    quantity.min = String(rule.min || 1);
    quantity.step = String(rule.increment || 1);
    if (rule.max !== null && rule.max !== undefined) quantity.max = String(rule.max);
    else quantity.removeAttribute('max');
    quantity.value = normaliseQuantity(quantity.value);
    document.documentElement.dataset.variantId = variant.id;
  }
  function colorFromLocation() {
    const params = new URLSearchParams(location.search);
    const variantId = params.get('variant');
    const matched = Object.keys(data.variants).find(color => data.variants[color].id === variantId);
    if (matched) return matched;
    const color = params.get('color');
    return Object.hasOwn(data.variants, color) ? color : data.defaultColor;
  }
  function selectColor(color, updateUrl = false, announce = false) {
    if (!Object.hasOwn(data.variants, color)) color = Object.hasOwn(data.variants, data.defaultColor) ? data.defaultColor : 'green';
    activeColor = color;
    const variant = data.variants[color];
    document.documentElement.dataset.color = color;
    $$('button[data-color]').forEach(button => {
      const selected = button.dataset.color === color;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    $$('[data-colour-label]').forEach(node => { node.textContent = variant.label; });
    applyImage($('#use-image'), variant.use);
    // Keep a lazy image visible while it loads. Hiding its ancestor here can
    // prevent the browser from ever requesting it; only an error hides it.
    sizeFigure.hidden = false;
    measurementSummary.classList.remove('visually-hidden');
    applyImage(sizeImage, variant.size);
    if (sizeImage.complete && sizeImage.naturalWidth > 0) setDimensionAvailability(true);
    rebuildGallery();
    renderPrice(variant);
    syncPurchase(variant);
    if (updateUrl) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('color', color);
        url.searchParams.set('variant', variant.id);
        if (url.href !== window.location.href) history.pushState({ color }, '', url);
      } catch { /* Some local-file contexts do not allow history updates. */ }
    }
    if (announce) $('#variant-status').textContent = variant.label + ' selected. Product, usage and dimension images updated.';
  }
  $$('button[data-color]').forEach(button => button.addEventListener('click', () => selectColor(button.dataset.color, true, true)));
  window.addEventListener('popstate', () => selectColor(colorFromLocation()));
  window.addEventListener('pageshow', event => { if (event.persisted) selectColor(colorFromLocation()); });
  applyImage($('#structure-image'), data.structure);
  if (incoming.structureCaption) $('.structure-figure figcaption').textContent = incoming.structureCaption;
  for (const [color, variant] of Object.entries(data.variants)) {
    if (variant.swatch) $$('button[data-color="' + color + '"] .swatch').forEach(node => { node.style.backgroundColor = variant.swatch; });
  }
  selectColor(colorFromLocation());

  const quantity = $('#quantity');
  function normaliseQuantity(value) {
    const input = $('#quantity');
    const min = Number(input.min) || 1;
    const step = Number(input.step) || 1;
    const max = input.hasAttribute('max') ? Number(input.max) : Infinity;
    const numeric = Number.isFinite(Number(value)) ? Number(value) : min;
    const rounded = min + Math.max(0, Math.floor((numeric - min) / step)) * step;
    return Math.min(min + Math.floor((max - min) / step) * step, Math.max(min, rounded));
  }
  $$('[data-quantity]').forEach(button => button.addEventListener('click', () => {
    quantity.value = normaliseQuantity(Number(quantity.value) + Number(button.dataset.quantity) * (Number(quantity.step) || 1));
  }));
  quantity.addEventListener('change', () => { quantity.value = normaliseQuantity(quantity.value); });
  $('.purchase-controls')?.addEventListener('submit', event => {
    const variant = data.variants[activeColor];
    if (variant?.available !== true) { event.preventDefault(); return; }
    quantity.value = normaliseQuantity(quantity.value);
    if (!event.currentTarget.reportValidity()) event.preventDefault();
  });

  function openImage(image, opener) {
    if (!image?.src || !image.naturalWidth) return;
    zoomOpener = opener;
    const enlarged = $('#dialog-image');
    enlarged.src = image.currentSrc || image.src;
    enlarged.alt = image.alt;
    enlarged.width = image.naturalWidth;
    enlarged.height = image.naturalHeight;
    $('#dialog-caption').textContent = image.alt;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
      document.body.classList.add('dialog-open');
      $('.dialog-close').focus();
    } else {
      window.open(image.currentSrc || image.src, '_blank', 'noopener');
    }
  }
  $('#hero-zoom').addEventListener('click', event => openImage(hero, event.currentTarget));
  $$('[data-zoom-target]').forEach(button => button.addEventListener('click', () => openImage(document.getElementById(button.dataset.zoomTarget), button)));
  $('.dialog-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('dialog-open');
    zoomOpener?.focus({ preventScroll: true });
  });
  // Native <dialog> handles Escape and focus containment.
})();

